// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cosmos Unchained API
 * Provides access to cosmos chain data.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';
import type { Value } from './Value';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
} from './Value';

/**
 * Contains info about a transaction
 * @export
 * @interface Tx
 */
export interface Tx {
    /**
     * 
     * @type {string}
     * @memberof Tx
     */
    blockHash?: string;
    /**
     * 
     * @type {number}
     * @memberof Tx
     */
    blockHeight: number;
    /**
     * 
     * @type {number}
     * @memberof Tx
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof Tx
     */
    txid: string;
    /**
     * 
     * @type {number}
     * @memberof Tx
     */
    confirmations: number;
    /**
     * Contains info about transaction events keyed by message index
     * @type {{ [key: string]: { [key: string]: { [key: string]: string; }; }; }}
     * @memberof Tx
     */
    events: { [key: string]: { [key: string]: { [key: string]: string; }; }; };
    /**
     * 
     * @type {Value}
     * @memberof Tx
     */
    fee: Value;
    /**
     * 
     * @type {string}
     * @memberof Tx
     */
    gasUsed: string;
    /**
     * 
     * @type {string}
     * @memberof Tx
     */
    gasWanted: string;
    /**
     * 
     * @type {number}
     * @memberof Tx
     */
    index: number;
    /**
     * 
     * @type {string}
     * @memberof Tx
     */
    memo?: string;
    /**
     * 
     * @type {Array<Message>}
     * @memberof Tx
     */
    messages: Array<Message>;
    /**
     * 
     * @type {string}
     * @memberof Tx
     */
    value: string;
}

/**
 * Check if a given object implements the Tx interface.
 */
export function instanceOfTx(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "blockHeight" in value;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "txid" in value;
    isInstance = isInstance && "confirmations" in value;
    isInstance = isInstance && "events" in value;
    isInstance = isInstance && "fee" in value;
    isInstance = isInstance && "gasUsed" in value;
    isInstance = isInstance && "gasWanted" in value;
    isInstance = isInstance && "index" in value;
    isInstance = isInstance && "messages" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function TxFromJSON(json: any): Tx {
    return TxFromJSONTyped(json, false);
}

export function TxFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tx {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'blockHash': !exists(json, 'blockHash') ? undefined : json['blockHash'],
        'blockHeight': json['blockHeight'],
        'timestamp': json['timestamp'],
        'txid': json['txid'],
        'confirmations': json['confirmations'],
        'events': json['events'],
        'fee': ValueFromJSON(json['fee']),
        'gasUsed': json['gasUsed'],
        'gasWanted': json['gasWanted'],
        'index': json['index'],
        'memo': !exists(json, 'memo') ? undefined : json['memo'],
        'messages': ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'value': json['value'],
    };
}

export function TxToJSON(value?: Tx | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'blockHash': value.blockHash,
        'blockHeight': value.blockHeight,
        'timestamp': value.timestamp,
        'txid': value.txid,
        'confirmations': value.confirmations,
        'events': value.events,
        'fee': ValueToJSON(value.fee),
        'gasUsed': value.gasUsed,
        'gasWanted': value.gasWanted,
        'index': value.index,
        'memo': value.memo,
        'messages': ((value.messages as Array<any>).map(MessageToJSON)),
        'value': value.value,
    };
}

